import Mosquiteras from './components/Mosquiteras'
import Cortinas from './components/Cortinas'
import Persianas from './components/Persianas'
// import Main from './components/Main';
import NavBar from './components/NavBar'

import Container from 'react-bootstrap/Container';

import { BrowserRouter, Route } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Suspense, lazy } from 'react';

const Main = lazy(() => import('./components/Main'))

function App() {

  return (
    <BrowserRouter>
      <Suspense fallback={
        <div className="text-center">
          <div className="spinner-border" style={{width: "3rem"}, {height: "3rem"}} role="status">
          </div>
        </div>
      }>
        <div>
          <NavBar />
          <Route exact path="/">
            <Main />
          </Route>
          <Route exact path="/mosquiteras">
            <Container >
              <Mosquiteras />
            </Container>
          </Route>
          <Route exact path="/cortinas">
            <Container >
              <Cortinas />
            </Container>
          </Route>
          <Route exact path="/persianas">
            <Container >
              <Persianas />
            </Container>
          </Route>
        </div>
      </Suspense>
    </BrowserRouter >
  );
}

export default App;
